module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="product-properties"></div>\n<div class="size-and-position-properties"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetPropertiesView.tpl
// module id = 2085
// module chunks = 0